import { Image, ParkFeature } from '@havenengineering/module-haven-content';

export class ParkFeatureWithImageAndIcon extends ParkFeature {
  images!: Image[];

  icon!: Image;

  age?: string;

  isNew?: boolean;
}

export const filterHighlightCarouselItems = (
  parkFeatures?: ParkFeature[],
): ParkFeatureWithImageAndIcon[] =>
  !parkFeatures
    ? []
    : (parkFeatures
        .filter(({ images, icon }) => images && images[0] && icon)
        .slice(0, 10) as ParkFeatureWithImageAndIcon[]);
